module.exports = __webpack_public_path__ + "Star/Star-bc9e9482b9288518d4c6baa521afbf0b.svg";